<div class="sub-panel">
    <div [routerLink]="navigationSubTab?.routerLink">{{ navigationSubTab?.label ?? "" | translate }}</div>
    @for (subTab of navigationSubTab?.subTabs; track subTab) {
        <app-navigation-sub-tab [navigationSubTab]="subTab"></app-navigation-sub-tab>
    }
</div>
